import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';
import { Role } from 'data/models/Role';
import { InviteUsers, InvitedUserViewModel } from './model';
import { PCModal } from 'portcall/pcmodal/view';
import { ValidationErrorView } from 'core/validationerror/view';
import * as cx from 'classnames';

export const InviteUsersView = SuperCritical(({ modelContainer } : { modelContainer : () => InviteUsers | null }) =>
    <PCModal className="inviteusers" shown={() => !!modelContainer()} onBackDropClick={modelContainer()?.HidePopup}>
        <div className="modal-content">
            {/*<loadingindicator params="request: Request" />*/}
            <div className="modal-header pc-modal-header">
                {(m => m && <button className="close pc-modal-close" onClick={m.HidePopup}>Close</button>)(modelContainer())}
                <h2 className="modal-title pc-modal-title">Invited</h2>
            </div>
            {(m => m &&
                <div className="modal-body inviteModal">
                    {m.SendInvitationRequest() && m.SendInvitationRequest()!.Response() && m.SendInvitationRequest()!.Response()!.Success ?
                        <InviteUsersSuccess onCloseModal={m.HidePopup} />
                        :
                        <InviteUsersInProgress model={m} />
                    }
                </div>
            )(modelContainer())}
        </div>
    </PCModal>
);

let InviteUsersSuccess = SuperCritical(({ onCloseModal } : { onCloseModal : () => void }) =>
    <div className="action-success clearfix">
        <div>
            Your invitations have been sent successfully.
        </div>
        <div>
            <button className="pc-button" onClick={onCloseModal}>
                OK
            </button>
        </div>
    </div>
);

let InviteUsersInProgress = SuperCritical(({ model: m } : { model : InviteUsers }) =>
    <div>
        {/*<actionloadingindicator params="action: SendInvitation" />*/}
        <SelectOrgView model={m} />
        <AddEmailsView model={m} />
        <SendInvitationsView model={m} />
    </div>
);

let SelectOrgView = SuperCritical(({ model: m } : { model : InviteUsers }) =>
    <div className="select-org">
        <SelectOrgLeftSide model={m} />
        <SelectOrgRightSide model={m} />
    </div>
);

let SelectOrgLeftSide = SuperCritical(({ model: m } : { model : InviteUsers }) =>
    <div className="content-left">
        <h2 className="step-title">
            Step 1: Select the New Person's Organization
        </h2>
        <div className="step-description">
            Select the new person's organization or add a new organization
            if it isn't already in the list.
        </div>
        {m.Model.CanManageOrgs() &&
            <div>
                <a href="" onClick={noDefault(() => m.Invitation.IsNewOrganization(true))}>
                    + Add a new organization
                </a>
            </div>
        }
    </div>
);

let SelectOrgRightSide = SuperCritical(({ model: m } : { model : InviteUsers }) =>
    <div className="content-right">
        <div className="selector-shell">
            {!m.Invitation.IsNewOrganization() ?
                <div className="org-select-container">
                    <select className="pc-select-secondary org-select"
                        value={m.Invitation.OrganizationId() || ''}
                        onChange={e => m.Invitation.OrganizationId(e.currentTarget.value ? +e.currentTarget.value : null)}
                        disabled={!m.Model.CanManageOrgs()}>
                        <option value="">--</option>
                        {m.Model.AvailableOrganizations().map(org =>
                            <option key={org.Id()} value={org.Id()}>{org.Name()}</option>
                        )}
                    </select>
                    <span className="pc-select-chevron"></span>
                    <ValidationErrorView error={() => m.Validation()['OrganizationId']} />
                </div>
                :
                <div className="new-org-name clearfix">
                    <input type="text" className="new-org-input form-control"
                            placeholder="Enter Organization Name"
                            value={m.Invitation.OrganizationName() || ''}
                            onChange={e => m.Invitation.OrganizationName(e.currentTarget.value)} />
                    <ValidationErrorView error={() => m.Validation()['OrganizationName']} />
                    {(err => err &&
                        <div className="validationerror alert alert-danger">
                            {err.ErrorText}
                            {' '}
                            <a href="" onClick={noDefault(() => m.SelectDuplicateOrg(+err.RawErrors[1]))}>
                                Select this organization instead?
                            </a>
                        </div>
                    )(m.Validation()['DuplicateOrganization'])}
                    <a href="" className="hide-org-btn" onClick={noDefault(() => m.Invitation.IsNewOrganization(false))}>Cancel</a>
                </div>
            }
        </div>
    </div>
);

let AddEmailsView = SuperCritical(({ model: m } : { model : InviteUsers }) =>
    <div className="add-emails">
        <div className="content-left">
            <h2 className="step-title">
                Step 2: Add Emails and Set Permissions
            </h2>
            <div className="step-description">
                Enter one or more email addresses for the new member(s) and indicate
                what they can do in PortCall.com.
            </div>
        </div>
        <AddEmailsRoleLabels model={m} />
        <AddEmailsInvitedUsers model={m} />
        <AddEmailsFooter model={m} />
    </div>
);

let AddEmailsRoleLabels = SuperCritical(({ model: m } : { model : InviteUsers }) =>
    <div className="content-right role-labels">
        {m.Model.AssignableRoles().map(r =>
            <span className="role-name" key={r.Id()}>{r.Name()}</span>
        )}
    </div>
);

let AddEmailsInvitedUsers = SuperCritical(({ model: m } : { model : InviteUsers }) =>
    <div>
        {m.InvitedUsers().map(user =>
            <AddEmailsInvitedUserView key={user.Key} user={user} assignableRoles={m.Model.AssignableRoles} />
        )}
    </div>
);

let AddEmailsInvitedUserView = SuperCritical(({ user, assignableRoles } : { user : InvitedUserViewModel, assignableRoles : () => Role[] }) =>
    <div className="invited-user clearfix">
        <div className="invited-user-row">
            <a href="" className="delete-row" onClick={noDefault(user.Delete)}>
                <i className="glyphicon glyphicon-remove-circle"></i>
            </a>
            <div className="email">
                <input type="text" className="pc-input-editcontrol"
                        placeholder="Email"
                        value={user.Model.Email()}
                        onChange={e => user.Model.Email((e.target as HTMLInputElement).value)} />
                <ValidationErrorView error={user.EmailValidation} />
            </div>
        </div>
        <InvitedUserRoles user={user} assignableRoles={assignableRoles} />
    </div>
);

let InvitedUserRoles = SuperCritical(({ user, assignableRoles } : { user : InvitedUserViewModel, assignableRoles : () => Role[] }) =>
    <div className="content-right">
        {assignableRoles().map(r =>
            <input key={r.Id()} className="checkbox" type="checkbox"
                checked={user.HasOrImpliesRole(r.Id())}
                disabled={user.ImpliesOrMaterializesRole(r.Id())}
                onChange={e => user.ToggleRole(r.Id())} />
        )}
    </div>
);

let AddEmailsFooter = SuperCritical(({ model: m } : { model : InviteUsers }) =>
    <div className="content-left">
        <ValidationErrorView error={() => m.Validation()['InvitedUsers']} />
        <a href="" onClick={noDefault(m.AddInvitedUser)}>
            + Invite another person from this organization
        </a>
    </div>
);

let SendInvitationsView = SuperCritical(({ model: m } : { model : InviteUsers }) =>
    <div className="send-invitations">
        <div className="content-left">
            <h2 className="step-title">
                Step 3: Send Invitations
            </h2>
            <div className="step-description">
                Click Send Invitation and each person will receive an email with a link
                to set their password.
            </div>
        </div>
        <div className="content-right">
            <div className="send-btn-shell">
                <button className="pc-button send-btn" onClick={m.Submit}>
                    Send Invitation
                </button>
            </div>
        </div>
    </div>
);


// WEBPACK FOOTER //
// ./apps/portcall/inviteusers/view.tsx